import * as React from 'react'
import cx from 'classnames'
import Tooltip from 'antd/lib/tooltip'
import PropTypes from 'prop-types'

import cls from '../EventForm.module.scss'

const InfoCircle = ({ info }) => (
  <Tooltip placement="right" title={info}>
    <span className={cx(cls.infoCircle, 'float-right text-center rounded-full text-base')}>?</span>
  </Tooltip>
)

InfoCircle.propTypes = {
  info: PropTypes.string,
}

export default InfoCircle
